import React from "react";
import Coup from "../Coupon";
import "../../Styling/NavCoupon.css";

const Coupons = () => {
  return (
    <div className="coup">
      <h1 style={{ marginTop: "15vh", textAlign: "center" }}></h1>
      <Coup />
    </div>
  );
};

export default Coupons;
